// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__Xnl1L","spin":"Loader_spin__1tCPV","circle":"Loader_circle__BQmvd"};